const KEY_PREFIX = 'river.openedVisits';

const keyFor = (providerUserId?: string) => `${KEY_PREFIX}.${providerUserId || 'anonymous'}`;

export const getOpenedVisits = (providerUserId?: string): Set<string> => {
  try {
    const raw = window.localStorage.getItem(keyFor(providerUserId));
    if (!raw) return new Set();
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? new Set(parsed as string[]) : new Set();
  } catch {
    return new Set();
  }
};

export const markVisitOpened = (visitId: string, providerUserId?: string) => {
  try {
    const opened = getOpenedVisits(providerUserId);
    if (opened.has(visitId)) return true;
    opened.add(visitId);
    window.localStorage.setItem(keyFor(providerUserId), JSON.stringify(Array.from(opened)));
    return true;
  } catch {
    return false;
  }
};

const BASELINE_PREFIX = 'river.visitsBaseline';

const baselineKeyFor = (providerUserId?: string) =>
  `${BASELINE_PREFIX}.${providerUserId || 'anonymous'}`;

// Without a baseline the release build finds an empty store and bolds every
// visit on the board at once.
const baselineFor = (providerUserId?: string): number => {
  const key = baselineKeyFor(providerUserId);

  try {
    const stored = window.localStorage.getItem(key);

    if (stored) {
      const parsed = Number(stored);
      if (!Number.isNaN(parsed)) return parsed;
    }

    const now = Date.now();
    window.localStorage.setItem(key, String(now));

    return now;
  } catch {
    return Date.now();
  }
};

export const isVisitNewToProvider = (
  visit: { id: string; createdAt?: string },
  providerUserId?: string,
) => {
  if (getOpenedVisits(providerUserId).has(visit.id)) return false;
  if (!visit.createdAt) return false;

  const submitted = new Date(visit.createdAt).getTime();

  if (Number.isNaN(submitted)) return false;

  return submitted > baselineFor(providerUserId);
};
